export const GROUP_CARBON = "Carbon Mode";
export const GROUP_FLEET = "Fleet";
export const GROUP_REPORTS = "Reports";
export const GROUP_NAVIGATION = "Navigation";
export const GROUP_ROBOT = "Robot";
